var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { computedFrom } from "aurelia-binding";
import { autoinject, transient } from "aurelia-dependency-injection";
import { I18N } from "aurelia-i18n";
import { DialogServiceConstants } from "../../../../../constants/basics/dialog.constants";
import { LookupValueRequest } from "../../../../../models/lookups/lookup.models";
import { DialogClientService } from "../../../../../services/basics/dialog-client.service";
import { NotificationClientService } from "../../../../../services/basics/notification-client.service";
import { LookupClientService } from "../../../../../services/lookups/lookup-client.service";
import { Guid } from "../../../../../utilities/guid";
import { ChildComponent } from "../../../../pages/modules/child-component";
var AppSettingBasicMeta = /** @class */ (function (_super) {
    __extends(AppSettingBasicMeta, _super);
    function AppSettingBasicMeta(notificationService, i18N, lookupClientService, dialogClientService) {
        var _this = _super.call(this, notificationService, i18N) || this;
        _this.lookupClientService = lookupClientService;
        _this.dialogClientService = dialogClientService;
        _this._permissionsEnabled = {};
        _this.apiItems = [];
        _this.apiPermissions = [];
        return _this;
    }
    Object.defineProperty(AppSettingBasicMeta.prototype, "permissionEnabled", {
        get: function () {
            return this._permissionsEnabled;
        },
        enumerable: false,
        configurable: true
    });
    AppSettingBasicMeta.prototype.generateKey = function () {
        var _this = this;
        if (this.item.apiKey != null) {
            if (!window["SystemJS"]) {
                require("" + "../../../../dialogs/generic-confirmation-dialog/generic-confirmation-dialog");
            }
            var model = {
                title: "Generate new API Key",
                confirm: "Confirm",
                cancel: "Cancel",
                onCancel: function () {
                },
                onConfirm: function () {
                    _this.item.apiKey = Guid.generateGuid();
                }
            };
            this.dialogClientService.show(DialogServiceConstants.URLs.GenericConfirmationDialog, model);
        }
        else {
            this.item.apiKey = Guid.generateGuid();
        }
    };
    AppSettingBasicMeta.prototype.attached = function () {
        var _this = this;
        var promise1 = this.lookupClientService.getLookup(new LookupValueRequest("apiItems"));
        var promise2 = this.lookupClientService.getLookup(new LookupValueRequest("apiPermissionTypes"));
        Promise.all([promise1, promise2]).then(function (x) {
            _this.apiItems = x[0].values;
            _this.apiPermissions = x[1].values;
        });
        if (this.item.apiSettingPermissions) {
            this.item.apiSettingPermissions.forEach(function (x) {
                _this._permissionsEnabled[x.apiItemId.toString() + x.apiPermissionTypeId.toString()] = true;
            });
        }
    };
    AppSettingBasicMeta.prototype.check = function (apiItem, apiPermission) {
        return this._permissionsEnabled[apiItem.id.toString() + apiPermission.id.toString()];
    };
    AppSettingBasicMeta.prototype.permissionChanged = function (apiItem, apiPermission) {
        if (!this.item.apiSettingPermissions)
            this.item.apiSettingPermissions = [];
        var apiPermissionItem = this.item.apiSettingPermissions.find(function (x) { return x.apiPermissionTypeId == apiPermission.id && x.apiItemId == apiItem.id; });
        if (apiPermissionItem) {
            var isPermissionAlreadyAdded = this._permissionsEnabled[apiItem.id.toString() + apiPermission.id.toString()];
            if (isPermissionAlreadyAdded)
                isPermissionAlreadyAdded = null;
            var index = this.item.apiSettingPermissions.indexOf(apiPermissionItem);
            this.item.apiSettingPermissions.splice(index, 1);
            this._permissionsEnabled[apiItem.id.toString() + apiPermission.id.toString()] = false;
        }
        else {
            this._permissionsEnabled[apiItem.id.toString() + apiPermission.id.toString()] = true;
            this.item.apiSettingPermissions.push({ apiItemId: apiItem.id, apiPermissionTypeId: apiPermission.id });
        }
    };
    __decorate([
        computedFrom("_permissionsEnabled"),
        __metadata("design:type", Object),
        __metadata("design:paramtypes", [])
    ], AppSettingBasicMeta.prototype, "permissionEnabled", null);
    AppSettingBasicMeta = __decorate([
        autoinject(),
        transient(),
        __metadata("design:paramtypes", [NotificationClientService, I18N, LookupClientService,
            DialogClientService])
    ], AppSettingBasicMeta);
    return AppSettingBasicMeta;
}(ChildComponent));
export { AppSettingBasicMeta };
